const PrivacyPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-20 mt-10">

      <h1 className="text-3xl md:text-4xl font-semibold mb-8 text-center">
        Privacy Policy
      </h1>

      <div className="space-y-6 text-gray-700 leading-relaxed">

        <p>
          Your privacy is important to us. This Privacy Policy explains how
          we collect, use, and protect your information when you use our website.
        </p>

        <div>
          <h2 className="text-xl font-medium mb-2">1. Information We Collect</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li>Name and contact details (such as phone number or email).</li>
            <li>Shipping address for order delivery.</li>
            <li>Order details and purchase history.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">2. How We Use Your Information</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li>To process and deliver your orders.</li>
            <li>To communicate regarding your purchases.</li>
            <li>To improve our website and customer experience.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">3. Data Protection</h2>
          <p>
            We do not sell, trade, or share your personal information with
            third parties except as required to fulfill your order.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">4. Cookies</h2>
          <p>
            Our website may use cookies to enhance user experience and
            analyze website traffic.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">5. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy,
            please contact us via WhatsApp or email.
          </p>
        </div>

      </div>
    </div>
  );
};

export default PrivacyPolicy;